export const endPoints = {
  BOSS_PAYMENT_DELAY: '/v1/mobile/payment/delay',
  BOSS_PAYMENT_DELAY_EXCEL: '/v1/mobile/payment/delay/excel'
};
